import { cloneDeep as e } from "../../../../utils/cloneDeep.js";
import { selectCtx as t, selectEvents as n } from "../core/models/selectors/index.js";
import { useDatePickerStore as r } from "../core/models/use-date-picker-store.js";
import { ad2bs as i } from "../calendar-carburettor/converter/index.js";
import { getStrategy as a } from "../core/libs/strategy/strategy-provider.js";
import { Pipeline as o } from "../utilities/pipeline.js";
import { commitCtx as s } from "../core/models/store.js";
import { Button as c } from "../../../button/index.js";
import { useMemo as l } from "react";
import { jsx as u, jsxs as d } from "react/jsx-runtime";
// src/design/forms/datepicker/ui/year-view.tsx
var f = (t) => {
	let n = e(t), r = a(n.isNepali), i = o();
	i.push(r.setGridYears);
	let { next: s } = i.execute({ next: n });
	return s.gridYears;
}, p = () => {
	let e = r(t);
	return l(() => f(e), [e]);
}, m = ({ onYearMonthClick: e }) => {
	let t = p(), { getNextDecadeYearGrid: i, getPreviousDecadeYearGrid: a } = r(n);
	return /* @__PURE__ */ d("div", {
		className: "flex w-full px-2 py-1 items-center justify-between",
		children: [
			/* @__PURE__ */ u(c.IconButton, {
				"aria-label": "previous-decade-button",
				size: "sm",
				variant: "ghost",
				colorScheme: "default",
				icon: "ChevronsLeft",
				id: "next-year-button",
				className: "bg-transparent p-2 hover:bg-muted rounded",
				onClick: a
			}),
			/* @__PURE__ */ u(c, {
				variant: "ghost",
				size: "sm",
				onClick: () => {
					e?.();
				},
				children: /* @__PURE__ */ d("p", {
					className: "p-2 text-sm font-semibold",
					children: [
						t[0],
						" - ",
						t[0] + 11
					]
				})
			}),
			/* @__PURE__ */ u(c.IconButton, {
				"aria-label": "next-decade-button",
				size: "sm",
				variant: "ghost",
				colorScheme: "default",
				icon: "ChevronsRight",
				id: "next-year-button",
				className: "bg-transparent p-2 hover:bg-muted rounded",
				onClick: i
			})
		]
	});
}, h = (e) => {
	if (t(e).isNepali) {
		let [t] = i(e.ctx.calendarReferenceDate).split("-");
		return t;
	}
	let [n] = e.ctx.calendarReferenceDate.split("-");
	return n;
}, g = ({ onSelection: t }) => {
	let i = r(h), l = p(), { setState: d } = r(n);
	return /* @__PURE__ */ u("div", {
		className: "overflow-hidden",
		children: /* @__PURE__ */ u("div", {
			className: "flex flex-wrap px-2 pb-3",
			children: l.map((n, r) => /* @__PURE__ */ u("div", {
				className: "col p-1 w-1/4",
				children: /* @__PURE__ */ u(c, {
					variant: "secondary",
					colorScheme: n + "" === i ? "primary" : "default",
					onClick: () => {
						d(async (t, r) => {
							let i = e(t().ctx), c = a(i.isNepali);
							await o().push(c.selectYear(n)).push(s(r)).execute({ next: i });
						}), t?.(n + "");
					},
					children: n
				})
			}, "Year-" + r))
		})
	});
}, _ = ({ children: e }) => e;
_.Control = m, _.Grid = g;
export { _ as yearView };

//# sourceMappingURL=year-view.js.map